// i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './translations/en.json';
import de from './translations/de.json';
import it from './translations/it.json';
import fr from './translations/fr.json';

const resources = {
  en: { translation: en },
  de: { translation: de },
  it: { translation: it },
  fr: { translation: fr },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'de',
  fallbackLng: 'de',
  supportedLngs: ['de', 'en', 'it', 'fr'],
  interpolation: { escapeValue: false },
});

export default i18n;
